export enum PrebidPriceGranularityType {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Auto = 'auto',
  Dense = 'dense',
}

export enum PrebidUserSyncFilterSettingType {
  Image = 'image',
  Iframe = 'iframe',
}

export enum PrebidConsentManagementCmpApiType {
  IAB = 'iab',
  Static = 'static',
}
